import { motion } from 'motion/react'
import clsx from 'clsx'

export default function ResetTransitionScreen() {
    return (
        <motion.div
            className='z-[60] absolute inset-0 overflow-hidden bg-white-stroke-even-darker'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.18, ease: 'easeOut' }}
        >
            <div
                aria-hidden
                className='absolute inset-0 opacity-5 mix-blend-multiply pointer-events-none'
                style={{
                    backgroundImage: "url('/images/Pattern5.png')",
                    backgroundSize: '123px 123px',
                }}
            />

            <img
                src='/images/LogoStacked.png'
                alt='Life Rush'
                className={clsx(
                    'absolute left-1/2 -translate-x-1/2 object-contain',
                    'top-1 w-72 h-auto',
                    'stele:top-12 stele:w-[26rem]'
                )}
            />

            <img
                src='/images/Chamele_Logo.png'
                alt=''
                aria-hidden
                className={clsx(
                    'absolute left-1/2 -translate-x-1/2 object-contain',
                    'bottom-[20%] w-40 h-auto',
                    'stele:bottom-[24%] stele:w-164'
                )}
                style={{ filter: 'drop-shadow(0px 4.9px 0px #5486ac)' }}
            />
        </motion.div>
    )
}
